import type { FullUserResponse } from "@/redux/users/types";

export interface SidebarProps {
  currentUser: FullUserResponse;
  isCollapsed: boolean;
  onToggleCollapsed: () => void;
}

export const SIDEBAR_TRIGGER_VARIANT = {
  SIDEBAR: "sidebar",
  HEADER: "header",
} as const;

export type SidebarTriggerVariant =
  (typeof SIDEBAR_TRIGGER_VARIANT)[keyof typeof SIDEBAR_TRIGGER_VARIANT];

export interface SidebarContentProps {
  currentUser: FullUserResponse;
  isCollapsed: boolean;
  showCollapseTrigger?: boolean;
  showLogo?: boolean;
  onToggleCollapsed?: () => void;
  className?: string;
  showFooterActions?: boolean;
}

export type RouteLeaf = {
  path: string;
  allowedRoles: string[];
  allowedOrgRoles: string[];
};
